'use client';

import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

import { usePathname } from 'next/navigation';

type HistoryContextType = string[];

const HistoryContext = createContext<HistoryContextType>([]);

export const HistoryProvider = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    setHistory((prev) => [pathname, ...prev]);
  }, [pathname]);

  return <HistoryContext.Provider value={history}>{children}</HistoryContext.Provider>;
};

export const useHistory = () => useContext(HistoryContext);
